import {APIResponseStatus} from 'common/types';
import {useSnackbar} from 'notistack';
import {useState} from 'react';
import {useIntl} from 'react-intl';
import {FeedbackAPI, SubmitFeedbackData} from 'services/FeedbackAPI';

export const useSubmitFeedback = (callback?: () => void): [
  boolean,
  (data: SubmitFeedbackData) => void,
] => {
  const snackbar = useSnackbar();
  const {formatMessage} = useIntl();
  const [isLoading, setLoading] = useState(false);
  const api = new FeedbackAPI();

  const submitFeedback = (data: SubmitFeedbackData) => {
    setLoading(true);
    api.submitFeedback(data)
      .then(response => {
        if (response.status === APIResponseStatus.Ok && callback) {
          callback();

          snackbar.enqueueSnackbar(
            'Дякуємо, ваш відгук відправлено!',
            {key: 'feedback_form'},
          );
        }
      })
      .catch(error => {
        console.debug(error);
        snackbar.enqueueSnackbar(
          formatMessage({id: 'errors.general'}),
          {key: 'feedback_form'},
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return [
    isLoading,
    submitFeedback,
  ];
};
